/**
 * 2-letter location codes for retailers, used in verification labels.
 * Format: MM-DD-LC-### (e.g., 02-24-UP-001)
 */
export const LOCATION_CODES: Record<string, string> = {
  "ups": "UP",
  "fedex": "FD",
  "wholefoods": "WF",
  "whole foods": "WF",
  "staples": "SP",
  "kohls": "KH",
  "kohl's": "KH",
};

/**
 * Display names for each location code
 */
export const LOCATION_NAMES: Record<string, string> = {
  "UP": "UPS",
  "FD": "FedEx",
  "WF": "Whole Foods",
  "SP": "Staples",
  "KH": "Kohl's",
};

/**
 * Get the 2-letter location code from a retailer string.
 * Strips "amazon-" prefix and looks up the code.
 */
export function getLocationCode(retailer: string): string {
  const cleaned = retailer.toLowerCase().replace(/^amazon[-\s]*/i, "").replace(/[()]/g, "").trim();
  
  // Direct match
  if (LOCATION_CODES[cleaned]) return LOCATION_CODES[cleaned];
  
  // Partial match
  for (const [key, code] of Object.entries(LOCATION_CODES)) {
    if (cleaned.includes(key)) return code;
  }
  
  // Fallback: first 2 letters uppercase
  return cleaned.substring(0, 2).toUpperCase();
}

/**
 * Get the display name for a location code
 */
export function getLocationName(code: string): string {
  return LOCATION_NAMES[code] || code;
}
